import axiosInstance from "./api";

// Fetch categories
export const getCategories = async () => {
  try {
    const response = await axiosInstance.get("/taxonomy/categories");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred fetching categories."
    );
  }
};

// Fetch expertises
export const getExpertises = async (role) => {
  try {
    const url = role ? `/taxonomy/expertises?role=${role}` : "/taxonomy/expertises";
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred fetching expertises."
    );
  }
};

// Fetch subcategories
export const getSubCategories = async (categoryIds = []) => {
  try {
    const categoryQuery = categoryIds.length > 0 
      ? `?categoryIds=${categoryIds.join(',')}` 
      : '';
    const response = await axiosInstance.get(`/taxonomy/subcategories${categoryQuery}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred fetching subcategories."
    );
  }
};

// Fetch cities matching query
export const getCities = async (query = "", includePending = false) => {
  try {
    const url = `/taxonomy/cities?q=${encodeURIComponent(query)}${includePending ? "&includePending=true" : ""}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred fetching cities."
    );
  }
};

// Fetch subexpertises
export const getSubExpertises = async (expertiseIds = [], subExpertiseIds = []) => {
  try {
    const params = new URLSearchParams();
    if (expertiseIds && expertiseIds.length > 0) params.append('expertiseIds', expertiseIds.join(','));
    if (subExpertiseIds && subExpertiseIds.length > 0) params.append('subExpertiseIds', subExpertiseIds.join(','));
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await axiosInstance.get(`/taxonomy/subexpertises${query}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred fetching subexpertises."
    );
  }
};
